import classNames from 'classnames'
import { CircleNotch } from 'phosphor-react'
import { Save } from '@mui/icons-material'
import { useAccess } from 'components/hooks/access'
import React from 'react'
import { Button } from 'ui'
import { T } from '@tolgee/react'
const WriterGeneratorActions = ({
  showSaveModal,
  clearInputs,
  handleSubmitWriterOptions,
  loading,
}) => {
  const hasAccess = useAccess()

  return (
    <>
      <Button
        color='gray'
        className='h-[45px] px-[18px]'
        onClick={() => showSaveModal()}
        data-tooltip-id='writer-writeText-saveTemplate'
      >
        <div
          className={classNames('flex items-center gap-[6px]', {
            'opacity-50': !hasAccess('Standard'),
          })}
        >
          <Save className='text-brand-secondary' />
        </div>
      </Button>
      <Button
        color='gray'
        className='h-[45px] min-w-[80px]'
        onClick={clearInputs}
        data-tooltip-id='writer-writeText-clear'
      >
        <p className='text-[15px] font-medium uppercase leading-none'>
          <T keyName='eleo-history-action-clear'>clear</T>
        </p>
      </Button>
      <Button
        className='h-[45px] w-full !px-2'
        color='dark'
        onClick={() => handleSubmitWriterOptions()}
        disabled={loading.name === 'generate' && loading.status}
        data-tooltip-id='writer-writeText-generateText'
      >
        {loading.name === 'generate' && loading.status ? (
          <CircleNotch weight='fill' color='#FFFFFF' size={24} className='animate-spin' />
        ) : (
          <p className='text-[15px] font-medium uppercase leading-none'>
            <T keyName='eleo-writer-action-generate-text'>generate text</T>
          </p>
        )}
      </Button>
    </>
  )
}

export default WriterGeneratorActions
